<template>
<div id="app">
    <router-view />
</div>
</template>

<style lang="scss">
@import './assets/sass/app.scss';
</style>

<script>
    export default {
        name: 'App',
        metaInfo: {
            titleTemplate: '%s | Image Bank'
        }
    }
</script>
